module.exports = __webpack_public_path__ + "static/media/calliptamus_italicus_001_APA.4a0213b6.png";